import ContactEdit from './ContactEdit';

export default ContactEdit;
